export default __webpack_public_path__ + "static/media/background2.77dc7278.svg";